// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__3m9f5","buttons":"RemoveExpirationActionButtons_buttons__1Kbz7"};